import 'babel-polyfill';
import App from 'App';

new App();
